import { render, staticRenderFns } from "./analyses.vue?vue&type=template&id=b0bc4406&"
import script from "./analyses.vue?vue&type=script&lang=ts&"
export * from "./analyses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports